// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "./node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "./node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    background-color: black;
    max-width: 1024px;
    margin: auto;
}

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

/* HEADER ------------------------------------------------------------------- */

.tb-header {
    color: #888;
    background-color: #400;
    padding: 5px 5px;
    overflow: auto;
    max-width: 1024px;
}

.tb-header::after {
    content: "";
    clear: both;
    display: table;
}

.tb-header-left {
    float: left;
}

.tb-header-right{
    float: right;
}

.tb-header-text-mobile {
    color: red;
}

.tb-header-text-desktop {
    display: none;
    color: white;
}

@media (pointer:fine) {
    .tb-header-text-mobile {
        display: none;
    }
    .tb-header-text-desktop {
        display: initial;
    }
}

/* CONTENT AREA ------------------------------------------------------------- */

/* Clear floats after the columns */
.tb-content {
    display: flex;
    flex-wrap: wrap;
    color: #ddd;
    background-color: #222;
}

.tb-sidebar {
    flex: 20%;
    padding: 20px;
    order: 1;
}

.tb-main {
    flex: 80%;
    padding: 20px;
    order: 2;
}

@media screen and (max-width: 768px) {
    .tb-content {
        flex-direction: column;
    }

    .tb-sidebar {
        flex: 100%;
        padding: 10px;
        order: 2;
    }

    .tb-main {
        flex: 100%;
        padding: 0px;
        order: 1;
    }
}

/* FOOTER ------------------------------------------------------------------- */

.tb-footer {
    background-color: #000;
    padding: 5px 5px;
    overflow: auto;
}

    .tb-footer::after {
        content: "";
        clear: both;
        display: table;
    }

.tb-footer-links {
    float: right;
}

/* SOCIAL LINKS ------------------------------------------------------------- */

.tb-social-links {
}

.tb-social-link {
    color: #888;
    font-size: 2em;
    /*background-color: #ccc;*/
    /*
    width: 30px;
    height: 30px;
    text-align: center;
    border-width: 0px;
    border-radius: 20px;
    margin: 2px;
    */
    padding: 4px;
}

@media (hover:hover) and (pointer:fine) {
    .tb-social-links .bi-twitter-x:hover {
        color: #ff0;
    }

    .tb-social-links .bi-wordpress:hover {
        color: #0ff;
    }

    .tb-social-links .bi-youtube:hover {
        color: #f00;
    }

    .tb-social-links .bi-instagram:hover {
        color: #0f0;
    }

    .tb-social-links .bi-facebook:hover {
        color: #44f;
    }
}

@media (pointer:fine) {
    .tb-social-link {
        font-size: 1em;
    }
}

/* SETTINGS LINKS ----------------------------------------------------------- */

.tb-settings {
}

.tb-settings-link {
    color: #888;
    font-size: 2em;
    /*
    width: 30px;
    height: 30px;
    text-align: center;
    border-width: 0px;
    border-radius: 20px;
    margin: 2px;
    */
    padding: 4px;
}

.tb-settings .bi-person-fill:hover {
    color: #ccc;
}

.tb-settings .bi-three-dots-vertical:hover {
    color: #ccc;
}

@media (pointer:fine) {
    .tb-settings-link {
        font-size: 1em;
    }
}
`, "",{"version":3,"sources":["webpack://./main.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA,+EAA+E;;AAE/E;IACI,WAAW;IACX,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI;QACI,aAAa;IACjB;IACA;QACI,gBAAgB;IACpB;AACJ;;AAEA,+EAA+E;;AAE/E,mCAAmC;AACnC;IACI,aAAa;IACb,eAAe;IACf,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,SAAS;IACT,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,UAAU;QACV,aAAa;QACb,QAAQ;IACZ;;IAEA;QACI,UAAU;QACV,YAAY;QACZ,QAAQ;IACZ;AACJ;;AAEA,+EAA+E;;AAE/E;IACI,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;AAClB;;IAEI;QACI,WAAW;QACX,WAAW;QACX,cAAc;IAClB;;AAEJ;IACI,YAAY;AAChB;;AAEA,+EAA+E;;AAE/E;AACA;;AAEA;IACI,WAAW;IACX,cAAc;IACd,0BAA0B;IAC1B;;;;;;;KAOC;IACD,YAAY;AAChB;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA,+EAA+E;;AAE/E;AACA;;AAEA;IACI,WAAW;IACX,cAAc;IACd;;;;;;;KAOC;IACD,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI;QACI,cAAc;IAClB;AACJ","sourcesContent":["body {\r\n    background-color: black;\r\n    max-width: 1024px;\r\n    margin: auto;\r\n}\r\n\r\n* {\r\n    margin: 0;\r\n    padding: 0;\r\n    box-sizing: border-box;\r\n}\r\n\r\n/* HEADER ------------------------------------------------------------------- */\r\n\r\n.tb-header {\r\n    color: #888;\r\n    background-color: #400;\r\n    padding: 5px 5px;\r\n    overflow: auto;\r\n    max-width: 1024px;\r\n}\r\n\r\n.tb-header::after {\r\n    content: \"\";\r\n    clear: both;\r\n    display: table;\r\n}\r\n\r\n.tb-header-left {\r\n    float: left;\r\n}\r\n\r\n.tb-header-right{\r\n    float: right;\r\n}\r\n\r\n.tb-header-text-mobile {\r\n    color: red;\r\n}\r\n\r\n.tb-header-text-desktop {\r\n    display: none;\r\n    color: white;\r\n}\r\n\r\n@media (pointer:fine) {\r\n    .tb-header-text-mobile {\r\n        display: none;\r\n    }\r\n    .tb-header-text-desktop {\r\n        display: initial;\r\n    }\r\n}\r\n\r\n/* CONTENT AREA ------------------------------------------------------------- */\r\n\r\n/* Clear floats after the columns */\r\n.tb-content {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    color: #ddd;\r\n    background-color: #222;\r\n}\r\n\r\n.tb-sidebar {\r\n    flex: 20%;\r\n    padding: 20px;\r\n    order: 1;\r\n}\r\n\r\n.tb-main {\r\n    flex: 80%;\r\n    padding: 20px;\r\n    order: 2;\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n    .tb-content {\r\n        flex-direction: column;\r\n    }\r\n\r\n    .tb-sidebar {\r\n        flex: 100%;\r\n        padding: 10px;\r\n        order: 2;\r\n    }\r\n\r\n    .tb-main {\r\n        flex: 100%;\r\n        padding: 0px;\r\n        order: 1;\r\n    }\r\n}\r\n\r\n/* FOOTER ------------------------------------------------------------------- */\r\n\r\n.tb-footer {\r\n    background-color: #000;\r\n    padding: 5px 5px;\r\n    overflow: auto;\r\n}\r\n\r\n    .tb-footer::after {\r\n        content: \"\";\r\n        clear: both;\r\n        display: table;\r\n    }\r\n\r\n.tb-footer-links {\r\n    float: right;\r\n}\r\n\r\n/* SOCIAL LINKS ------------------------------------------------------------- */\r\n\r\n.tb-social-links {\r\n}\r\n\r\n.tb-social-link {\r\n    color: #888;\r\n    font-size: 2em;\r\n    /*background-color: #ccc;*/\r\n    /*\r\n    width: 30px;\r\n    height: 30px;\r\n    text-align: center;\r\n    border-width: 0px;\r\n    border-radius: 20px;\r\n    margin: 2px;\r\n    */\r\n    padding: 4px;\r\n}\r\n\r\n@media (hover:hover) and (pointer:fine) {\r\n    .tb-social-links .bi-twitter-x:hover {\r\n        color: #ff0;\r\n    }\r\n\r\n    .tb-social-links .bi-wordpress:hover {\r\n        color: #0ff;\r\n    }\r\n\r\n    .tb-social-links .bi-youtube:hover {\r\n        color: #f00;\r\n    }\r\n\r\n    .tb-social-links .bi-instagram:hover {\r\n        color: #0f0;\r\n    }\r\n\r\n    .tb-social-links .bi-facebook:hover {\r\n        color: #44f;\r\n    }\r\n}\r\n\r\n@media (pointer:fine) {\r\n    .tb-social-link {\r\n        font-size: 1em;\r\n    }\r\n}\r\n\r\n/* SETTINGS LINKS ----------------------------------------------------------- */\r\n\r\n.tb-settings {\r\n}\r\n\r\n.tb-settings-link {\r\n    color: #888;\r\n    font-size: 2em;\r\n    /*\r\n    width: 30px;\r\n    height: 30px;\r\n    text-align: center;\r\n    border-width: 0px;\r\n    border-radius: 20px;\r\n    margin: 2px;\r\n    */\r\n    padding: 4px;\r\n}\r\n\r\n.tb-settings .bi-person-fill:hover {\r\n    color: #ccc;\r\n}\r\n\r\n.tb-settings .bi-three-dots-vertical:hover {\r\n    color: #ccc;\r\n}\r\n\r\n@media (pointer:fine) {\r\n    .tb-settings-link {\r\n        font-size: 1em;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
